import { render, staticRenderFns } from "./PatientOverviewStress.vue?vue&type=template&id=36ccb5ff&"
import script from "./PatientOverviewStress.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewStress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports